import { render, staticRenderFns } from "./ProductLayoutFormField.vue?vue&type=template&id=2cdd6ad6&scoped=true&"
import script from "./ProductLayoutFormField.vue?vue&type=script&lang=js&"
export * from "./ProductLayoutFormField.vue?vue&type=script&lang=js&"
import style0 from "./ProductLayoutFormField.vue?vue&type=style&index=0&id=2cdd6ad6&lang=scss&scoped=true&"
import style1 from "./ProductLayoutFormField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd6ad6",
  null
  
)

export default component.exports